import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Carousel from './Carousel';

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fitCards: false,
      maxCardsOnPage: 0,
      cardWidth: 226, //must match carouselProps.settings.slideWidth
    };

    this.calculateMaxCardsPerPage = this.calculateMaxCardsPerPage.bind(this);
    this.resizeHandler = this.resizeHandler.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  /**
   * Called when window resize event is fired
   * */
  resizeHandler() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
    }

    this.timeoutHandler = setTimeout(() => {
      this.onResize();
    }, 400);
  }

  /**
   * Called when window resize event stops
   * */
  onResize() {
    this.calculateMaxCardsPerPage();
  }

  /**
   * Calculates the maximum cards per page
   * */
  calculateMaxCardsPerPage() {
    const { cardWidth } = this.state;
    const container = ReactDOM.findDOMNode(this.container);
    const pinnedItemsLength = (this.props.pinnedItems || []).length;
    const itemsLength = (this.props.items || []).length;
    const width = container.clientWidth;
    let containerWidth = pinnedItemsLength
      ? width - pinnedItemsLength * cardWidth
      : width;
    const maxCardsOnPage = containerWidth / cardWidth;

    /**
     * fitCards - if maxCardsOnPage module is 0 - then we have the cards fit the screen
     * */
    const fixedNumber = Math.ceil(maxCardsOnPage);
    const fitCards =
      fixedNumber > itemsLength ? true : maxCardsOnPage % 1 === 0;

    this.setState({
      maxCardsOnPage: fixedNumber,
      fitCards: fitCards && this.props.settings.slideIndex === 0,
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler);
    this.calculateMaxCardsPerPage();
  }

  componentDidUpdate(prevProps) {
    const previousItems = prevProps.items || [];
    const latestItems = this.props.items || [];
    if (latestItems.length !== previousItems.length) {
      this.calculateMaxCardsPerPage();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  render() {
    const { cardWidth, maxCardsOnPage, fitCards } = this.state;
    const { containerAttributes } = this.props;

    const carouselProps = {
      ...this.props,
      cardWidth,
      maxCardsOnPage,
      fitCards,
      containerAttributes,
    };

    return (
      <Carousel ref={(node) => (this.container = node)} {...carouselProps} />
    );
  }
}

export default Index;
